import { render } from "./AttendViaPaymentLink.vue?vue&type=template&id=c18ec3a8"
import script from "./AttendViaPaymentLink.vue?vue&type=script&lang=js"
export * from "./AttendViaPaymentLink.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__